import { FETCH_TENANT_LIST_SUCCESS, FETCH_TENANT_LIST_REQUEST, FETCH_TENANT_LIST_FAILURE, FETCH_TENANT_LIST_RESET } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getTenantListReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TENANT_LIST_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_TENANT_LIST_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_TENANT_LIST_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_TENANT_LIST_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default getTenantListReducer;
